import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "helpers/api_helper";

export const fetchProfileStatus = createAsyncThunk(
    'profileStatus/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosApi.get('profile/status', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('auth_token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const profileStatusSlice = createSlice({
    name: 'profileStatus',
    initialState: {
        isProfileComplete: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfileStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProfileStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.isProfileComplete = action.payload?.isProfileComplete;
            })
            .addCase(fetchProfileStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default profileStatusSlice.reducer;
